// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getStorage} from "firebase/storage"
import {getAuth} from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC4PgMzVfUdCUWKgND4ytBGHTaRhsRYbfk",
    authDomain: "location-tracker-io.firebaseapp.com",
    projectId: "location-tracker-io",
    storageBucket: "location-tracker-io.firebasestorage.app",
    messagingSenderId: "600821214108",
    appId: "1:600821214108:web:1fc049bd38b3e1e87eb659",
    measurementId: "G-01K1218M7E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app)
const auth = getAuth(app)
export {app, analytics, storage, auth};
